import { DB_PREFIX } from './constants';

export default {
  [DB_PREFIX]: {
    firstName: '',
    lastName: '',
    photoURL: '',
    title: '',
    dateOfBirth: '',
    mobilePhone: '',
    gender: '',
    nationality: '',
  },
};
